module.exports = __webpack_public_path__ + "img/house.131a0dbd.png";